module.exports = __webpack_public_path__ + "static/img/ac-xyph.c403ffc8.jpg";